import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  Form,
} from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { List } from "react-bootstrap-icons";
import "../style/admin.css";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { GrCart } from "react-icons/gr";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import { apibasePath } from "../config";
const SlideOne = () => {
  const [cart, setCart] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [displayData, setDisplayData] = useState([]);
  const [itemCode, setItemCode] = useState("");
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("All");
  const [show, setShow] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [brandLogo, setBrandLogo] = useState(null);

  const [cartCount, setCartCount] = useState(0);

  const [minSizes, setMinSizes] = useState([]);
  const [maxSizes, setMaxSizes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [count, setcount] = useState(0);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [sizes, setSizes] = useState([]);

  const Token = localStorage.getItem("token");

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    handleAllitem();
    fetchdatas();
  }, []);

  const customerApi = `${apibasePath}/client/customer-name/`;

  const fetchCustomerName = async () => {
    const Token = localStorage.getItem("token");

    try {
      let response = await axios.get(customerApi, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Customer API Response:", response.data);

      if (response.data?.name) {
        setCustomerName(response.data.name); // Set name only if it exists
      } else {
        console.warn("Customer name not found in API response");
      }
    } catch (error) {
      console.error("Error fetching customer name:", error);
    }
  };

  useEffect(() => {
    fetchCustomerName();
  }, []);
  const addToCart = (product) => {
    setCart([...cart, product]);
  };

  const handleClick = (item) => {
    if (item === "All") {
      handleAllitem();
    } else {
      fetchItemData(item);
    }
    setSelectedItem(item === "All" ? "Products" : item.item_name);
  };

  const All_Api = `${apibasePath}/client/customer-item-stock-list/`;

  const handleAllitem = async () => {
    const Token = localStorage.getItem("token");

    try {
      setLoading(true);
      const res = await axios.get(All_Api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      setSelectedItem("Products");
      setDisplayData(res.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchItemData = async (item) => {
    const Token = localStorage.getItem("token");

    setItemCode(item.item_code);

    try {
      setLoading(true);
      const res = await axios.get(
        `${apibasePath}/client/customer-item-stock/${item.item_code}/`,
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setDisplayData(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error while getting data", error);
      setLoading(false);
    }
  };

  /* sdngjfjbjnbbnebntbtbnt */

  const [filters, setFilters] = useState({
    gross_weight_min: "",
    gross_weight_max: "",
    net_weight_min: "",
    net_weight_max: "",
    stone_weight_min: "",
    stone_weight_max: "",
    size_min: "",
    size_max: "",
  });

  const updateHistory = (newFilters) => {
    const params = new URLSearchParams();
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value !== "") params.set(key, value);
    });

    const newUrl = `?${params.toString()}`;
    const currentUrl = window.location.search;
    if (currentUrl !== newUrl) {
      window.history.pushState(newFilters, "", newUrl);
    }
  };

  const applyFilters = async () => {
    updateHistory(filters);
    const Token = localStorage.getItem("token");
    try {
      setLoading(true);

      const queryParams = new URLSearchParams();
      if (minSizes.length > 0)
        queryParams.append("size_min", minSizes.join(","));
      if (maxSizes.length > 0)
        queryParams.append("size_max", maxSizes.join(","));

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== "") queryParams.append(key, value);
      });

      const url = `${apibasePath}/client/customer-item-stock-list/?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      setDisplayData(data);
    } catch (error) {
      console.error("Error while fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFiltersFromUrl = async (urlFilters) => {
    const Token = localStorage.getItem("token");
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();
      Object.entries(urlFilters).forEach(([key, value]) => {
        if (value !== "") queryParams.append(key, value);
      });

      const url = `${apibasePath}/client/customer-item-stock-list/?${queryParams.toString()}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setDisplayData(data);
    } catch (error) {
      console.error("Error fetching filtered data from URL:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlFilters = {
      gross_weight_min: params.get("gross_weight_min") || "",
      gross_weight_max: params.get("gross_weight_max") || "",
      net_weight_min: params.get("net_weight_min") || "",
      net_weight_max: params.get("net_weight_max") || "",
      stone_weight_min: params.get("stone_weight_min") || "",
      stone_weight_max: params.get("stone_weight_max") || "",
      size_min: params.get("size_min") || "",
      size_max: params.get("size_max") || "",
    };
    setFilters(urlFilters);

    if ([...params.values()].some((val) => val !== null && val !== "")) {
      applyFiltersFromUrl(urlFilters);
    }

    fetchData();
    handleAllitem();
    fetchdatas();
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      const state = event.state;
      if (state) {
        setFilters(state);
        applyFiltersFromUrl(state);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  /* sandeepsomethingsomethingbadami jgkwrjgr,rrbnr */

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  const handleCheckBoxChange = (event) => {
    const { name, checked, value } = event.target;

    if (name === "size_min") {
      setMinSizes(
        checked ? [value] : minSizes.filter((size) => size !== value),
      ); // Modify this line
    } else if (name === "size_max") {
      setMaxSizes(
        checked ? [value] : maxSizes.filter((size) => size !== value),
      ); // Modify this line
    }
  };

  const SizeCheckboxes = ({ handleCheckBoxChange }) => {
    const [sizes, setSizes] = useState([]);

    const sizeApi = `${apibasePath}/client/available-sizes/`;

    useEffect(() => {
      const fetchSizeData = async () => {
        try {
          const response = await axios.get(sizeApi);
          setSizes(response.data);
        } catch (error) {
          console.error("Error fetching sizes:", error);
        }
      };

      fetchSizeData();
    }, []);
  };

  const API_URL = `${apibasePath}/client/cart/add/`;

  const handleAddToCart = async (product) => {
    const Token = localStorage.getItem("token");

    try {
      setLoading(true);
      const payload = product;
      const response = await axios.post(API_URL, payload, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      setCartItems((prevCart) => [...prevCart, product.item_tag]);
      setCartCount(cartCount + 1);
      setLoading(false);
    } catch (error) {
      console.error("Error adding to cart", error);
      setLoading(false);
      if (error.response && error.response.status === 400) {
        alert("Item already in cart. Please update the quantity.");
        if (!cartItems.includes(product.item_tag)) {
          setCartItems((prevCart) => [...prevCart, product.item_tag]);
        }
      } else {
        alert("An error occurred while adding to cart.");
      }
    }
  };

  const Api_Url = `${apibasePath}/client/customer-items/`;

  const [itemData, setItemData] = useState([]);

  const fetchData = async () => {
    const Token = localStorage.getItem("token");

    try {
      setLoading(true);
      const res = await axios.get(Api_Url, {
        headers: {
          Authorization: `bearer ${Token}`,
        },
      });
      setItemData(res.data);
      setLoading(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  const Api_url = `${apibasePath}/client/profiles/company/`;

  const fetchdatas = async () => {
    try {
      const response = await axios.get(Api_url, {
        headers: { "Content-Type": "application/json" },
      });
      setLogo(response.data.logo);
      setName(response.data.name);
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  const handleSidebarClose = () => setShowSidebar(false);
  const handleSidebarShow = () => setShowSidebar(true);

  if (loading) {
    return (
      <div
        style={{
          top: "50%",
          left: "50%",
          translate: ("-50%", "-50%"),
          position: "absolute",
        }}
        className="slide"
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="slide">
      <Navbar className="bg-body-tertiary fixed-top" expand="md">
        <Container fluid>
          <Navbar.Brand>
            <div
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={logo}
                alt="companylogo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {customerName}
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            <Button
              variant="outline-light"
              className="d-md-none"
              onClick={handleSidebarShow}
            >
              <RxHamburgerMenu
                style={{
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                  color: "#000",
                }}
              />
            </Button>
            <Navbar.Brand className="cart">
              <a href="/add-to-cartdetails">
                <GrCart
                  style={{ width: "30px", height: "30px", color: "#396D72" }}
                />
              </a>
            </Navbar.Brand>
          </div>
        </Container>
      </Navbar>

      <Container fluid>
        <Row>
          {/* Sidebar - Always visible on larger screens, collapsible on mobile */}

          <Col
            md={3}
            className="p-3 d-none d-md-block fixed-sidebar "
            style={{
              backgroundColor: "#396D72",
              height: "130vh",
              marginTop: "70px",
            }}
          >
            {/* <h5 className="text-white">Jewellery Items</h5> */}
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                style={{
                  color: "#fff",
                  border: "none",
                  fontSize: "20px",
                  fontfamily: "Roboto",
                  fontWeight: "500",
                  lineHeight: "1.2",
                  letterSpacing: "0",
                  marginLeft: "22px",
                }}
              >
                {selectedItem}
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  backgroundImage:
                    "linear-gradient(to bottom left,#C7E0E3, #FFFFFF ) ",
                }}
              >
                <Dropdown.Item onClick={() => handleClick("All")} key="all">
                  All Products
                </Dropdown.Item>
                {itemData.map((item, index) => (
                  <Dropdown.Item key={index} onClick={() => handleClick(item)}>
                    {item.item_name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* filters */}

            <div>
              <Form style={{ paddingTop: "20px", marginLeft: "30px" }}>
                {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
                <Form.Group>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Size
                  </Form.Label>{" "}
                  <br />
                  <div
                    className="checks"
                    style={{
                      display: "flex",
                      color: "#fff",
                      justifyContent: "space-between",
                      backgroundColor: "transparent",
                    }}
                  >
                    <div>
                      {sizes.map((size, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          onChange={handleCheckBoxChange}
                          name="size_min"
                          value={size}
                          label={size}
                          className="mb-2 transparent-checkbox"
                        />
                      ))}
                    </div>
                    <div style={{ marginRight: "80px" }}>
                      {sizes.map((size, index) => (
                        <Form.Check
                          key={`max-${index}`}
                          type="checkbox"
                          onChange={handleCheckBoxChange}
                          name="size_max"
                          value={size}
                          label={size}
                          className="mb-2 transparent-checkbox"
                        />
                      ))}
                    </div>
                  </div>
                </Form.Group>

                {/* Gross Weight */}
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Gross Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      name="gross_weight_min"
                      value={filters.gross_weight_min}
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="gross_weight_max"
                      value={filters.gross_weight_max}
                      onChange={handleInputChange}
                    />{" "}
                  </div>
                </Form.Group>

                {/* Net Weight */}
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Net Weight
                  </Form.Label>
                  <div style={{ display: "flex", marginTop: "3px" }}>
                    <Form.Control
                      type="number"
                      name="net_weight_min"
                      value={filters.net_weight_min}
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="net_weight_max"
                      value={filters.net_weight_max}
                      onChange={handleInputChange}
                    />{" "}
                  </div>
                </Form.Group>

                {/* Stone Weight */}
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Stone Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      name="stone_weight_min"
                      value={filters.stone_weight_min}
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="stone_weight_max"
                      value={filters.stone_weight_max}
                      onChange={handleInputChange}
                    />{" "}
                  </div>
                </Form.Group>

                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Stone Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      name="size_min"
                      value={filters.size_min}
                      onChange={handleInputChange}
                    />
                    <Form.Control
                      type="number"
                      name="size_max"
                      value={filters.size_max}
                      onChange={handleInputChange}
                    />{" "}
                  </div>
                </Form.Group>

                {/* Size */}
                {/* <Form.Group style={{ paddingTop: '10px' }}>
                                    <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Roboto' }}>Size</Form.Label>
                                    <div style={{ display: 'flex' }}>
                                        <Form.Control type="number" name="size_min" style={{ backgroundColor: 'transparent', color: '#fff' }} placeholder="Min" onChange={handleInputChange} />
                                        <Form.Control type="number" name="size_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
                                    </div>
                                </Form.Group> */}

                {/* Apply Filters Button */}
                <div
                  align="center"
                  className="apply_button"
                  style={{ marginTop: "50px" }}
                >
                  <Button
                    style={{
                      backgroundColor: "#fff",
                      color: "#23395B",
                      boxShadow: "0px 0px 7px 0px #000",
                      border: "none",
                    }}
                    className="pe-4 ps-4 mt-4 me-4"
                    variant="light"
                    onClick={applyFilters}
                  >
                    Apply Filters
                  </Button>
                </div>
              </Form>
            </div>
          </Col>

          {/* Offcanvas Sidebar for Mobile */}
          <Offcanvas
            show={showSidebar}
            onHide={handleSidebarClose}
            placement="start"
          >
            <Offcanvas.Header
              className="custom-offcanvas-header"
              variant="light"
              closeButton
              style={{ backgroundColor: "#396D72", color: "#fff" }}
            >
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={{ backgroundColor: "#396D72" }}>
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  style={{ color: "#fff", border: "none", fontSize: "20px" }}
                >
                  {selectedItem}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleClick("All")} key="all">
                    All Products
                  </Dropdown.Item>
                  {itemData.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleClick(item)}
                    >
                      {item.item_name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div align="end">
                <Navbar.Brand className="">
                  <a href="/add-to-cartdetails">
                    <GrCart
                      style={{ width: "33px ", height: "31px", color: "#fff" }}
                    />
                  </a>
                </Navbar.Brand>
              </div>

              {/* filters */}
              <div>
                <Form style={{ paddingTop: "20px" }}>
                  {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Size
                    </Form.Label>{" "}
                    <br />
                    <div
                      className="checks"
                      style={{
                        display: "flex",
                        color: "#fff",
                        justifyContent: "space-between",
                        backgroundColor: "transparent",
                      }}
                    >
                      <div>
                        {sizes.map((size, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            name="size_min"
                            value={size}
                            label={size}
                            className="mb-2 transparent-checkbox"
                          />
                        ))}
                      </div>
                      <div style={{ marginRight: "80px" }}>
                        {sizes.map((size, index) => (
                          <Form.Check
                            key={`max-${index}`}
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            name="size_max"
                            value={size}
                            label={size}
                            className="mb-2 transparent-checkbox"
                          />
                        ))}
                      </div>
                    </div>
                  </Form.Group>
                  {/* Gross Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Gross Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        type="number"
                        name="gross_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                      />
                      <Form.Control
                        type="number"
                        name="gross_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Net Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Net Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        type="number"
                        name="net_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                      />
                      <Form.Control
                        type="number"
                        name="net_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Stone Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Stone Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        type="number"
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        name="stone_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                      />
                      <Form.Control
                        type="number"
                        name="stone_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Size */}
                  {/* <Form.Group style={{ paddingTop: '10px' }}>
                                        <Form.Label style={{ color: 'white', fontSize: '20px', fontFamily: 'Poppins' }}>Size</Form.Label>
                                        <div style={{ display: 'flex' }}>
                                            <Form.Control type="number" style={{
                                                backgroundColor: 'transparent',
                                                color: '#fff'
                                            }} name="size_min" placeholder="Min" onChange={handleInputChange} />
                                            <Form.Control type="number" name="size_max" placeholder="Max" onChange={handleInputChange} style={{ marginLeft: '10px', backgroundColor: 'transparent', color: '#fff' }} />
                                        </div>
                                    </Form.Group> */}

                  {/* Apply Filters Button */}
                  <div
                    align="center"
                    style={{ marginTop: "50px" }}
                    className=""
                  >
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        color: "#23395B",
                        boxShadow: "0px 0px 7px 0px #000",
                        border: "none",
                      }}
                      className="pe-4 ps-4 mt-4 me-4"
                      variant=""
                      onClick={applyFilters}
                    >
                      Apply Filters
                    </Button>
                  </div>
                </Form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* //product items */}

          <Col
            md={9}
            className="scrollable-content"
            style={{ marginTop: "70px" }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              {displayData && displayData.length > 0 ? (
                displayData.map((product) => (
                  <Card
                    style={{
                      width: "18rem",
                      height: "30rem",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      borderRadius: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        onClick={() =>
                          navigate(`/customer-items/${product.id}`)
                        }
                        variant="top"
                        src={
                          product.image ? product.image : "./images/noimage.jpg"
                        }
                        style={{
                          width: "100%",
                          height: "100%",
                          // backgroundSize: 'contain',
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    <Card.Body
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flexGrow: 1,
                      }}
                    >
                      <div align="center">
                        <p
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            fontSize: "18px",
                            lineHeight: "0",
                            letterSpacing: "0",
                          }}
                        >
                          {product.item_tag}
                        </p>
                        <p
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            fontSize: "18px",
                            lineHeight: "1",
                            letterSpacing: "0",
                          }}
                        >
                          {product.item_name}
                        </p>
                      </div>
                      <Card.Text
                        style={{ marginTop: "10px", marginLeft: "25%" }}
                      >
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Gross Wt&nbsp; : {product.gross_weight} gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
                          {product.net_weight} gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Stone Wt&nbsp; : {product.stone_weight} gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                          {product.size}{" "}
                        </p>
                      </Card.Text>
                    </Card.Body>
                    <Button
                      variant="primary"
                      className="w-100 mt-2"
                      style={{
                        backgroundColor: cartItems.includes(product.item_tag)
                          ? "#396D72"
                          : "#D1B457",
                        // backgroundColor:'#D1B457',
                        border: "none",
                        borderBottomLeftRadius: "13px",
                        borderBottomRightRadius: "13px",
                        borderTopRightRadius: "0",
                        borderTopLeftRadius: "0",
                      }}
                      onClick={() => handleAddToCart(product)}
                      disabled={cartItems.includes(product.item_tag)}
                    >
                      {cartItems.includes(product.item_tag)
                        ? "Added to Cart"
                        : "Add to Cart"}
                    </Button>
                  </Card>
                ))
              ) : (
                <Col className="text-centere">
                  <p
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      alignItems: "center",
                    }}
                  >
                    No Items to display
                  </p>
                </Col>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <hr style={{ border: "1px solid #000000" }} />

      <div
        className="address"
        style={{
          // marginLeft: "auto",
          // marginRight: "auto",
          marginTop: "30px",
          // borderTop: "1px solid",
          fontFamily: "Roboto",
          fontWeight: "500",
          maxWidth: "600px", // Limit the width for better readability on larger screens
          padding: "0 20px", // Add padding for smaller screens
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "30px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Shubham jewellers
          </h3>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Address
          </h2>
          <p
            style={{
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Sri Shubham jewellery, 2 nd floor 201/202, mayur kushal complex
            abids, Gunfoundry, Hyderabad 500001, Telegana, India
          </p>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Phone
          </h2>
          <p
            style={{
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            +919949946000
          </p>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Email
          </h2>
          <p
            style={{
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            srishubhamjewellers@gmail.com
          </p>
        </div>
      </div>
      <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <h4
            align="center"
            style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
          >
            POWERED BY
          </h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5px", //add some space between text and logo
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideOne;
